import React from 'react';
import classNames from 'classnames';
import { TwainGameId } from 'betgames-contract-js';
import sortBy from '@betgames/bg-tools/dist/utils/sortBy';
import { SortDirection } from '@betgames/bg-tools/dist/enums/SortDirection';
import { translationProvider } from 'twain-sport-fe-mono/store/translations';
import { IParticipantDetailedStatistics } from 'twain-sport-fe-mono/interfaces';
import { StatisticItem } from './StatisticItem';
import { StatisticValueSkeleton } from './ParticipantProfileStatisticsSkeleton';
import classes from './ParticipantProfileStatistics.module.scss';

const disallowedStatistics = [
    'gamesPlayed',
    'tournamentsPlayed',
    'tournamentsWon',
    'wins',
    'finalReached',
    'semifinalReached',
];

interface IProps {
    statistics: IParticipantDetailedStatistics[];
    pending?: boolean;
    gameId?: TwainGameId;
    columnView?: boolean;
}

export const ParticipantProfileStatistics: React.FC<IProps> = (props) => {
    const t = translationProvider;
    const statistics = props.statistics.filter((item) => !disallowedStatistics.includes(item.name));
    const gamesPlayed = props.statistics.find((item) => item.name === 'gamesPlayed');

    const Skeleton = React.useMemo(
        () =>
            Array(4)
                .fill(null)
                .map((_, i) => <StatisticItem pending key={i} />),
        [],
    );

    return (
        <div className={classes.container}>
            <h3 className={classes.gamePlayed}>
                {t.string('games_played')}
                {props.pending ? (
                    <StatisticValueSkeleton />
                ) : (
                    <span className={classes.badge}>{gamesPlayed?.value || 0}</span>
                )}
            </h3>
            <div
                className={classNames(classes.itemsContainer, {
                    [classes.columnView]: props.columnView,
                })}
            >
                {props.pending
                    ? Skeleton
                    : [...statistics]
                          .sort(sortBy((stat) => stat.name, SortDirection.DESC))
                          .map((item) => (
                              <StatisticItem
                                  key={item.name}
                                  name={item.name}
                                  rank={item.rank}
                                  type={item.type}
                                  value={item.value}
                                  bestValue={item.bestValue}
                                  gameId={props.gameId}
                                  columnView={props.columnView}
                              />
                          ))}
            </div>
            <div className={classes.filter} />
        </div>
    );
};
